import { render } from "./Toolbar.vue?vue&type=template&id=4c9664d8"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/mike/VueCode/service-package-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__